// extracted by mini-css-extract-plugin
export default {"provider-card-footer":"_1NsyHXagVmd_tu_ES4Nq6E"};